namespace RioERP.Users {
    export interface CustomersWhatsAppForm {
        Status: Serenity.EnumEditor;
        RowIds: Serenity.StringEditor;
    }

    export class CustomersWhatsAppForm extends Serenity.PrefixedContext {
        static formKey = 'Users.CustomersWhatsAppForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomersWhatsAppForm.init)  {
                CustomersWhatsAppForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;

                Q.initFormType(CustomersWhatsAppForm, [
                    'Status', w0,
                    'RowIds', w1
                ]);
            }
        }
    }
}
